// extracted by mini-css-extract-plugin
export default {"verticalDivider":"VerticalDivider_verticalDivider__SRGow"};